<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Kandidat ausschließen</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<h2>{{ applicantName }}</h2>
			<template v-if="hasBothPermissions">
				<div class="mb-3">
					Soll die Person nur für diesen Job oder auch für weitere/künftige Jobs ausgeschlossen werden?
				</div>
				<RadioGroup
					v-model="exclusionType"
					:options="exclusionTypeOptions"
					stacked
				/>
			</template>
			<template v-else>
				<div v-if="permissionJobProfile">
					Soll die Person wirklich für diesen Job ausgeschlossen werden?
				</div>
				<div v-if="permissionComprehensive">
					Soll die Person wirklich für alle Jobs ausgeschlossen werden?
				</div>
			</template>
		</main>
		<footer>
			<Button
				text="Kandidat ausschließen"
				icon="checkmark"
				:disabled="!dataValid || saving"
				:loading="saving"
				@click="exclude"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import RadioGroup from "@/vue/common/form/RadioGroup";
import {isDefined} from "@/helper/Value";
import JobProfileExclusion from "@/api/customer/job-profile/applicant/Exclusion";
import CustomerExclusion from "@/api/customer/applicant/Exclusion";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";
import {get} from "@/helper/job-profile/applicant/Name";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job-result/exclusion/applicant";

const EXCLUSION_TYPE_JOB_PROFILE = 'job-profile';
const EXCLUSION_TYPE_CUSTOMER = 'customer';

export default {

	components: {
		Button,
		Icon,
		RadioGroup,
	},

	data ()
	{
		return {
			exclusionType: undefined,
			exclusionTypeOptions: [
				{value: EXCLUSION_TYPE_JOB_PROFILE, text: 'Nur von diesem Job ausschließen'},
				{value: EXCLUSION_TYPE_CUSTOMER, text: 'Von ALLEN derzeitigen und künftigen Jobs ausschließen'},
			],
			saving: false,
		};
	},

	computed: {
		...mapState('jobResult/exclusion/applicant', [
			'show',
			'jobProfileId',
			'jobId',
			'applicant',
			'permissionJobProfile',
			'permissionComprehensive'
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		applicantName ()
		{
			return get(this.applicant);
		},
		hasBothPermissions ()
		{
			return this.permissionJobProfile && this.permissionComprehensive;
		},
		forcedExclusionType ()
		{
			if (this.hasBothPermissions)
			{
				return null;
			}

			return this.permissionJobProfile
				? EXCLUSION_TYPE_JOB_PROFILE
				: EXCLUSION_TYPE_CUSTOMER;
		},
		exclusionTypeValid ()
		{
			return this.forcedExclusionType || isDefined(this.exclusionType);
		},
		dataValid ()
		{
			return this.exclusionTypeValid;
		}
	},

	methods: {
		...mapActions('jobResult/exclusion/applicant', [
			'close'
		]),
		async exclude ()
		{
			this.saving = true;

			try
			{
				if (this.exclusionType === EXCLUSION_TYPE_JOB_PROFILE)
				{
					await new JobProfileExclusion()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.setExcludedAtJob(this.jobId)
						.add()
						.call();
				}
				else
				{
					await new CustomerExclusion()
						.setPseudonymId(this.applicant.id)
						.setExcludedAtJob(this.jobId)
						.add()
						.call();
				}

				EventBus.$emit(Event.JOB_PROFILE_APPLICANT_EXCLUDED, {
					applicant: this.applicant,
					exclusionType: this.exclusionType,
				});

				this.closeFan({
					exclusionType: this.exclusionType,
					saved: true
				});
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
		closeFan (data)
		{
			this.exclusionType = undefined;

			this.close(data);
		}
	},
}
</script>
